import Vue from 'vue'
import Router from 'vue-router'
import store from '../store';
import Cookie from 'js-cookie'

Vue.use(Router)

let fastLogin = sessionStorage.getItem('fastLogin') || '' // 是否快速登录

const main = [{
        path: '/',
        // path: '/login',
        name: 'login',
        component: () => import ('../views/login/login.vue'),
        meta: {
            title: '登录',
            tab:false,
            eventCode: 'mifi_login_page_show'
        }
    },
    {
        path: '/fastLogin',
        name: 'fastLogin',
        component: () => import('../views/login/fastLogin.vue'),
        meta: {
            title: '快速登录',
            tab: false,
        }
    },
    {
        path: '/forget',
        name: 'forget',
        component: () => import('../views/login/forget.vue'),
        meta: {
            title: '忘记密码',
            tab: false,
            login: false
        }
    },
    {
        path: '/bindmobile',
        name: 'bindmobile',
        component: () =>
            import ('../views/userInfo/bindmobile.vue'),
        meta: {
            title: '绑定手机号',
            tab:false
        }
    },
    {
        path: '/getCode',
        name: 'getCode',
        component: () =>
            import ('../views/userInfo/getCode.vue'),
        meta: {
            title: '获取code',
            tab:false
        }
    },
    {
        path: '/personal',
        name: 'personal',
        component: () =>
            import ('../views/personal/personal.vue'),
        meta: {
            title: '用户中心',
            tab:true
        }
    },
    {
        path: '/changeCard',
        name: 'changeCard',
        component: () =>
            import ('../views/personal/changeCard/changeCard.vue'),
        meta: {
            title: '换卡管理',
            tab:false
        }
    },
    {
        path: '/afterSalesOrderDetail',
        name: 'afterSalesOrderDetail',
        component: () =>
            import ('../views/personal/afterSalesOrderDetail/index.vue'),
        meta: {
            title: '售后订单详情',
            tab:false
        }
    },
    {
        path: '/userInfo',
        name: 'userInfo',
        component: () =>
            import ('../views/userInfo/userInfo.vue'),
        meta: {
            title: '用户信息',
            tab:true
        }
    },
    {
        path: '/wireLessDevice',
        name: 'wireLessDevice',
        component: () =>
            import ('../views/wireLessDevice/wireLessDevice.vue'),
        meta: {
            title: '无线设备连接列表',
            tab:false
        }
    },
    {
        path: '/deviceList',
        name: 'deviceList',
        component: () =>
            import ('../views/deviceList/deviceList.vue'),
        meta: {
            title: '设备管理',
            tab:false
        }
    },
    {
        path: '/addDevice',
        name: 'addDevice',
        component: () =>
            import ('../views/addDevice/addDevice.vue'),
        meta: {
            title: '添加/查询设备',
            tab:false
        }
    },
    {
        path: '/device',
        name: 'device',
        component: () =>
            import ('../views/addDevice/device.vue'),
        meta: {
            title: '添加设备',
            tab:false,
            eventCode: 'mifi_fir_band_page_show',
        }
    },
    {
        path: '/packageDetail',
        name: 'packageDetail',
        component: () =>
            import ('../views/packageDetail/packageDetail.vue'),
        meta: {
            title: '套餐余量',
            tab:false
        }
    },
    {
        path: '/usePackageDetail',
        name: 'usePackageDetail',
        component: () =>
            import ('../views/packageDetail/usePackageDetail.vue'),
        meta: {
            title: '流量详细',
            tab:false
        }
    },
    {
        path: '/bill',
        name: 'bill',
        component: () =>
            import ('../views/bill/bill.vue'),
        meta: {
            title: '账单中心',
            tab:false
        }
    },
    {
        path: '/balance_record',
        name: 'balance_record',
        component: () =>
            import ('../views/bill/balance_record.vue'),
        meta: {
            title: '余额记录',
            tab:false
        }
    },
    {
        path: '/refund',
        name: 'refund',
        component: () =>
            import ('../views/refund/refund.vue'),
        meta: {
            title: '退款进度',
            tab:false
        }
    },
    {
        path: '/package',
        name: 'package',
        component: () =>
            import ('../views/package/package.vue'),
        meta: {
            title: '充值中心',
            tab:true
        }
    },
    {
        path: '/recharge',
        name: 'recharge',
        component: () =>
            import ('../views/package/recharge.vue'),
        meta: {
            title: '充值余额',
            tab:true
        }
    },
    {
        path: '/success',
        name: 'success',
        component: () =>
            import ('../views/package/success.vue'),
        meta: {
            title: '充值中心',
            tab:true
        }
    },
    {
        path: '/payResult',
        name: 'payResult',
        component: () =>
            import ('../views/package/payResult.vue'),
        meta: {
            title: '支付成功',
            tab:true,
            login: false,
        }
    },
    {
        path: '/aliPayResult',
        name: 'alipayResult',
        component: () =>
            import ('../views/package/ali-payResult.vue'),
        meta: {
            title: '支付成功',
            tab:true,
            login: false,
        }
    },
    {
        path: '/renewal',
        name: 'renewal',
        component: () =>
            import ('../views/personal/renewal.vue'),
        meta: {
            title: '自动续费管理',
            tab:true
        }
    },
    {
        path: '/notice',
        name: 'notice',
        component: () =>
            import ('../views/notice/notice.vue'),
        meta: {
            title: '消息通知',
            tab:false
        }
    },
    {
        path: '/noticeDetail',
        name: 'noticeDetail',
        component: () =>
            import ('../views/notice/noticeDetail.vue'),
        meta: {
            title: '消息详情',
            tab:false
        }
    },
    {
        path: '/about',
        name: 'about',
        component: () =>
            import ('../views/about/about.vue'),
        meta: {
            title: '关于',
            tab:false
        }
    },
    {
        path: '/diagnosis',
        name: 'diagnosis',
        component: () =>
            import ('../views/diagnosis/diagnosis.vue'),
        meta: {
            title: '智能诊断',
            tab:false
        }
    },
    {
        path: '/customerService',
        name: 'customerService',
        component: () =>
            import ('../views/diagnosis/customer-service.vue'),
        meta: {
            title: '扫码联系客服',
            tab:false
        }
    },
    {
        path: '/questionType',
        name: 'questionType',
        component: () =>
            import ('../views/question/questionType.vue'),
        meta: {
            title: '问题分类列表',
            tab:false
        }
    },
    {
        path: '/questionInfo',
        name: 'questionInfo',
        component: () =>
            import ('../views/question/questionInfo.vue'),
        meta: {
            title: '问题分类详情',
            tab:false
        }
    },
    {
        path: '/giveAway',
        name: 'giveAway',
        component: () =>
            import ('../views/package/giveAway.vue'),
        meta: {
            title: '领取赠品',
            tab:false
        }
    },
    {
        path: '/deviceAuthManagement',
        name: 'deviceAuthManagement',
        component: () =>
            import ('../views/deviceAuthManagement/index.vue'),
        meta: {
            title: '上网认证',
            tab:false
        }
    },
]

// 退换货
const goodsBack = [
    {
        path: "/fb-goodsReturn",
        name: "fb-goodsReturn",
        component: () =>
            import ('@/views/feedback/fb-goodsReturn'),
        meta: { title: "退货", tab:false},
    },
    {
        path: "/fb-goodsExchange",
        name: "fb-goodsExchange",
        component: () =>
            import ('@/views/feedback/fb-goodsExchange'),
        meta: { title: "换货", tab:false},
    }
]

const feedback = [{
        path: "/fb-list",
        name: "fb-list",
        component: () =>
            import ('@/views/feedback/fb-list'),
        meta: { title: "反馈", tab:false, login: false},
    },
    {
        path: "/fb-info",
        name: "fb-info",
        component: () =>
            import ('@/views/feedback/fb-info'),
        meta: { title: "反馈详情", tab:false, login: false},
    },
    {
        path: "/fb-add",
        name: "fb-add",
        component: () =>
            import ('@/views/feedback/fb-add'),
        meta: { title: "新增反馈", tab:false, login: false},
    },
    {
        path: "/fb-type",
        name: "fb-type",
        component: () =>
            import ('@/views/feedback/fb-type'),
        meta: { title: "问题类型", tab:false, login: false},
    },
    {
        path: "/fb-new",
        name: "fb-new",
        component: () =>
            import ('@/views/feedback/fb-new'),
        meta: { title: "新增反馈", tab:false, login: false},
    },

]
const realName = [{
        path: "/realName-index",
        name: "realName-index",
        component: () =>
            import ('@/views/realName/queryRealName'),
        meta: {
            title: "实名查询",
            login: false,
            tab:false,
            eventCode: 'mifi_realname_page_show',
        },
    },
    {
        path: "/realName-idcard",
        name: "realName-idcard",
        component: () =>
            import ('@/views/realName/idcardRealName'),
        meta: { title: "完善入网资料", login: false, tab:false},
    },
    {
        path: "/realName-hub",
        name: "realName-hub",
        component: () =>
            import ('@/views/realName/realNameHub'),
        meta: { title: "实名认证", login: false, tab:false},
    },
    {
        path: "/realName-operator",
        name: "realName-operator",
        component: () =>
            import ('@/views/realName/operatorRealName'),
        meta: { title: "运营商实名", login: false, tab:false},
    },
    {
        path: "/realName-handle",
        name: "realName-handle",
        component: () =>
            import ('@/views/realName/handleRealName'),
        meta: { title: "手动实名", login: false, tab:false},
    },
    {
        path: "/realName-success",
        name: "realName-success",
        component: () =>
            import ('@/views/realName/realNameSuccess'),
        meta: { title: "实名成功", login: false, tab:false},
    },
    {
        path: "/realName-error",
        name: "realName-error",
        component: () =>
            import ('@/views/realName/realNameError'),
        meta: { title: "实名失败", login: false, tab:false},
    },
    {
        path: "/realName-wait",
        name: "realName-wait",
        component: () =>
            import ('@/views/realName/realNameWait'),
        meta: { title: "实名审核中", login: false, tab:false},
    },
    {
        path: "/huideRealName",
        name: "huideRealName",
        component: () =>
            import ('@/views/realName/huideRealName'),
        meta: { title: "实名", login: false, tab:false},
    },
    // v2.14.1 新增匠岩实名
    {
        path: '/checkRealName',
        name: 'checkRealName',
        component: () =>import('@/views/realName/checkRealName'),
        meta: { title: "实名认证", login: false, tab:false},
    }
]

//引导页 设备管理页
const guideEquipment = [
		{
			path: "/tutorial-description",
			name: "tutorial-description",
			component: () =>
					import ('@/views/guideEquipment/tutorial-description'),
			meta: { title: "教程说明", tab:false, login: false},
		}
]

// 优惠券
const couponRoutes = [
    {
        path: "/coupon",
        name: "coupon",
        component: () =>import('@/views/coupon/index.vue'),
        meta: { title: "优惠券",tab:false, login: false},
    }
]

// v2.10.1活动套餐相关
const activityRoutes = [
    {
        path: "/act-equipment",
        name: "act-equipment",
        component: () => import('@/views/activity/equipment.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    },
    {
        path: "/act-meal",
        name: "act-meal",
        component: () => import('@/views/activity/meal.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    },
    {
        path: "/meal-order",
        name: "meal-order",
        component: () => import('@/views/activity/meal-order.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    },
    {
        path: "/not-satisfied",
        name: "not-satisfied",
        component: () => import('@/views/activity/not-satisfied.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    },
    {
        path: "/pay-fail",
        name: "pay-fail",
        component: () => import('@/views/activity/pay-fail.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    },
    {
        path: "/pay-success",
        name: "pay-success",
        component: () => import('@/views/activity/pay-success.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    },
    {
        path: "/act-pay",
        name: "act-pay",
        component: () => import('@/views/activity/pay.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    },
    {
        path: "/act-order",
        name: "act-order",
        component: () => import('@/views/activity/act-order.vue'),
        meta: {
            title: "", tab:false, login: false
        }
    }
]

// v3.3.1快速登录相关
const fastRoutes = [
    {
        path: "/fast-activation",
        name: "fast-activation",
        component: () => import('@/views/fast/activation.vue'),
        meta: {
            title: "设备激活", tab:false, login: false
        }
    },
]

// v4.0 扫码跳转相关
const agentCodeRoutes = [
    {
        path: '/scanCode',
        name: 'scanCode',
        component: () =>import('@/views/agentCode/scanCode.vue'),
        meta: { title: "设备激活", tab:false, login: false},
    },
    {
        path: '/bind-equipment',
        name: 'bind-equipment',
        component: () => import('@/views/agentCode/bind-equipment.vue'),
        meta: { title: "设备激活", tab:false, login: false },
    }
]

// 发票相关
const billRoutes = [
    {
        path: '/changeBill',
        name: 'changeBill',
        component: () =>
            import ('../views/bill/changeBill.vue'),
        meta: {
            title: '选择订单开票',
            tab:false
        }
    },
    {
        path: '/billMsg',
        name: 'billMsg',
        component: () =>
            import ('../views/bill/billMsg.vue'),
        meta: {
            title: '填写开票信息',
            tab:false
        }
    },
    {
        path: '/billFinish',
        name: 'billFinish',
        component: () =>
            import ('../views/bill/billFinish.vue'),
        meta: {
            title: '开票结果',
            tab:false
        }
    },
    {
        path: '/billDetail',
        name: 'billDetail',
        component: () =>
            import ('../views/bill/billDetail.vue'),
        meta: {
            title: '发票详细',
            tab:false
        }
    },
]
// 联系客服
const serviceLandingRoutes = [
    // 直播电商客服
    {
        path: "/service-landing",
        name: "service-landing",
        component: () =>import('@/views/serviceLanding/index.vue'),
        meta: { title: "联系客服",tab:false, login: false},
    },
    // 一类电商客服
    {
        path: "/service-landing-1",
        name: "service-landing-1",
        component: () =>import('@/views/serviceLanding-1/index.vue'),
        meta: { title: "联系客服",tab:false, login: false},
    }
]

const router = new Router({
    mode: 'hash',
    routes: [
        ...main,
        ...feedback,
        ...realName,
        ...goodsBack,
		...guideEquipment,
        ...activityRoutes,
        ...fastRoutes,
        ...agentCodeRoutes,
        ...couponRoutes,
        ...billRoutes,
        ...serviceLandingRoutes,
    ]
})

router.beforeEach((to, from, next) => {
    let packageUrl = sessionStorage.getItem('packageUrl')
    // 授权回来之后拿到返回路由直接返回
    if (['login','fastLogin'].includes(to.name)  && packageUrl ) {
        router.replace({
            name: packageUrl
        })
        return
    }


    if (Boolean(to.meta.title)) {
        document.title = to.meta.title
    }

    if (!Boolean(to.name)) {
        // next({
        //     name: fastLogin?'fastLogin':'login'
        // })
        if (!to.query.t) {
            next({ ...to, query: { ...to.query, t: Date.now() },  name: fastLogin?'fastLogin':'login'})
        } else {
            next({
                name: fastLogin?'fastLogin':'login'
            })
        }
        return
    }
    if (to.meta.hasOwnProperty('login') && to.meta.login === false) {
        // next()
        if (!to.query.t) {
            next({ ...to, query: { ...to.query, t: Date.now() }})
        } else {
            next()
        }
        return
    }
    // 未登录前往非登录页
    let token = (store.state.user.token || Cookie.get('mifiToken')) || localStorage.getItem('agentToken') || ''
    // to.name != 'login' && to.name != 'bindmobile'
    if (!['login','bindmobile','fastLogin'].includes(to.name) && !Boolean(token)) {
        // next({
        //     name: fastLogin?'fastLogin':'login'
        // })
        if (!to.query.t) {
            next({ ...to, query: { ...to.query, t: Date.now() }, name: fastLogin?'fastLogin':'login'})
        } else {
            next({
                name: fastLogin?'fastLogin':'login'
            })
        }
        return
    }

    if (to.name == "getCode" && to.query.code) {
        // next();
        if (!to.query.t) {
            next({ ...to, query: { ...to.query, t: Date.now() }})
        } else {
            next()
        }
        return;
    }

    // 登录后 前往登录页
    if (to.name == 'login' && Boolean(token)) {
        // next({
        //     name: 'personal'
        // })
         if (!to.query.t) {
            next({ ...to, query: { ...to.query, t: Date.now() }, name: 'personal'})
        } else {
            next({name: 'personal'})
        }
        return
    }

    // next()
    if (!to.query.t) {
        next({ ...to, query: { ...to.query, t: Date.now() }})
    } else {
        next()
    }
    return
})

//获取原型对象上的push函数
const originalPush = Router.prototype.push;
//修改原型对象中的push方法
Router.prototype.push = function push(location) {
  return originalPush.call(this, location).catch((err) => err);
};

// /**
//  * 重写路由的replace方法
//  */
const routerReplace = Router.prototype.replace;
Router.prototype.replace = function push(location) {
  return routerReplace.call(this, location).catch((error) => error);
};



export default router


// WEBPACK FOOTER //
// ./src/router/index.js